import styled, { keyframes, css } from 'styled-components';

interface ArrowMoveProps {
  isAnimating?: boolean;
}

const chevronMove = keyframes`
  0% { opacity: 0; transform: translateX(0); }
  33% { opacity: 1; transform: translateX(2px); }
  66% { opacity: 0; transform: translateX(4px); }
  100% { opacity: 0; }
`;

const Chevron = styled.span<{ delay: string; isAnimating: boolean }>`
  display: inline-block;
  opacity: ${({ isAnimating }) => (isAnimating ? 0 : 1)};
  transform: ${({ isAnimating }) => (isAnimating ? 'translateX(0)' : 'none')};
  ${({ isAnimating, delay }) =>
    isAnimating &&
    css`
      animation: ${chevronMove} 1.25s ease-in-out infinite;
      animation-delay: ${delay};
    `}
`;

const ChevronWrapper = styled.span`
  display: inline-flex;
  margin-left: 0.5rem;
`;

const ChevronMove = ({ isAnimating = true }: ArrowMoveProps) => {
  return (
    <ChevronWrapper>
      <Chevron delay="0s" isAnimating={isAnimating}>
        {'>'}
      </Chevron>
      <Chevron delay="0.25s" isAnimating={isAnimating}>
        {'>'}
      </Chevron>
      <Chevron delay="0.5s" isAnimating={isAnimating}>
        {'>'}
      </Chevron>
    </ChevronWrapper>
  );
};

export default ChevronMove;
